// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"29":"16f0313d","89":"e9bad35e","154":"485901db","192":"80b7a10f","374":"89bfa6f5","388":"e3669fa2","494":"a5d6f2b7","682":"e1ff9510","699":"ec20b9e1","748":"ef3709c5","905":"53c2b112","927":"c27fb4cf","955":"6eef82e3","970":"e64db0de"}[chunkId] + ".js";
};